var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',[_c('v-main',[[_c('Header'),_c('OverlayIcon'),(_vm.loader)?_c('Loader'):_vm._e(),_c('router-view'),_c('Footer')]],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }